import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { deleteTask } from '@/modules/Task/gql/task.gql'
import { SnackType } from '@/interfaces/snack'
import { Task } from '@/modules/Task/interfaces/task'
import { showErrors, showNotification } from '@/utils/snack'
import TaskForm from '@/modules/Task/components/TaskForm.vue'

@Component({
  components: {
    AppDialog,
    AppTextSearch,
    TaskForm
  }
})
export default class TaskDialog extends mixins() {
  targetTask: Task | null = null

  taskDialog = {
    show: false,
    title: 'New Task',
    disable: false,
    actionType: 'new',
    highlightTitle: ''
  }

  deleteTaskDialog = {
    show: false,
    title: 'Delete Task',
    disable: false
  }

  showTaskDialog (targetTask?: Task) {
    let actionType = 'new'
    let title = 'New Task'
    let highlightTitle = ''
    if (targetTask) {
      this.targetTask = targetTask
      actionType = 'edit'
      title = 'Edit Task'
    }
    this.taskDialog = {
      actionType,
      show: true,
      title,
      disable: false,
      highlightTitle
    }
  }

  hideTaskDialog () {
    this.targetTask = null
    this.taskDialog = {
      actionType: 'copy',
      show: false,
      title: 'New Task',
      disable: false,
      highlightTitle: ''
    }
  }

  async deleteTask (e: Event, targetTask: Task) {
    e.preventDefault()
    e.stopPropagation()
    this.targetTask = targetTask
    this.deleteTaskDialog.show = true
  }

  async deleteTaskPost () {
    if (!this.targetTask) {
      return
    }
    const { id } = this.targetTask
    this.deleteTaskDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteTask,
        variables: {
          taskId: Number(id)
        }
      })

      const res = result.data.deleteTask
      if (res) {
        showNotification({
          msg: 'Delete task successfully',
          type: SnackType.Success
        })
        this.targetTask = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
